
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"-2 -2 28 28","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-rule":"evenodd","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M12 .253a4.502 4.502 0 00-4.388 3.5H1.5a1 1 0 100 2h1.096l1.298 12.823c.073.73.135 1.334.224 1.826.092.513.227.98.488 1.414a4 4 0 001.72 1.555c.502.237 1.032.32 1.614.354.17.01.35.017.539.021a1 1 0 00.042-2c-.172-.003-.324-.009-.46-.017-.48-.029-.715-.089-.881-.167a2 2 0 01-.86-.777c-.086-.142-.163-.345-.234-.738-.074-.406-.128-.933-.206-1.711L4.606 5.753h14.788l-.288 4.151a1 1 0 101.99.202l.308-4.353H22.5a1 1 0 100-2h-6.111A4.502 4.502 0 0012 .253zm-2.292 3.5a2.5 2.5 0 014.584 0H9.708z"}}),_c('path',{attrs:{"d":"M12.258 14.01a1 1 0 000 1.415l2.828 2.828-2.829 2.829a1 1 0 001.415 1.414l2.828-2.828 2.828 2.828a1 1 0 001.415-1.414l-2.829-2.829 2.829-2.828a1 1 0 00-1.415-1.414L16.5 16.839l-2.828-2.828a1 1 0 00-1.415 0z"}})])])
          )
        }
      }
    